export default {
  POST_BEGIN: "POST_BEGIN",
  POST_SUCCESS: "POST_SUCESS",
  POST_FAILURE: "POST_FAILURE",

  GET_HAPPINESS_BEGIN: "GET_HAPPINESS_BEGIN",
  GET_HAPPINESS_SUCCESS: "GET_HAPPINESS_SUCCESS",
  GET_HAPPINESS_FAILURE: "GET_HAPPINESS_FAILURE",

  GET_USER_BEGIN: "GET_USER_BEGIN",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_FAILURE: "GET_USER_FAILURE",
};



// WEBPACK FOOTER //
// ./src/modules/diary/constants.js